// eslint-disable-next-line import/prefer-default-export
export function getViewport(w = window) {
  return { width: w.innerWidth, height: w.innerHeight };
}
